import React, { useEffect, useState } from "react";
import {
  Upload,
  Button,
  message,
  Row,
  Col,
  Typography,
  Form,
  Alert,
  Collapse,
} from "antd";
import { InfoCircleOutlined, UploadOutlined } from "@ant-design/icons";
import type { UploadProps } from "antd";
import type { UploadChangeParam } from "antd/lib/upload";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import EditableTable from "./EditableTable"; // Assume you've split this into its own component
import { BASE_URL } from "../../App";
import getCookie from "../Common/Utils";
import { postApi } from "../../Api/Api";
import { useAuth } from "../../Context/authContext";
import {
  showNotyError,
  showNotyInfo,
  showNotySucess,
} from "../Common/notificationUtils";
import { RcFile } from "antd/es/upload/interface";
import { FILE_UPLOAD_CONFIG } from "./FileMessageRouteConfig";

interface FileData {
  key: string;
  fileName: string;
  format: string;
  fileSize: number;
  artist: string;
  track: string;
  notes: string;
  progress: number;
  uploadKey?: string;
}
const { Title, Text, Paragraph } = Typography;

const UploadPage: React.FC = () => {
  const [fileList, setFileList] = useState<FileData[]>([]);
  const location = useLocation();
  const [asset, setAsset] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [uploadKey, setUploadKey] = useState<string>("");
  const navigate = useNavigate();
  const { setActiveButton, user } = useAuth();
  const { id } = useParams();
  const [form] = Form.useForm();
  useEffect(() => {
    if (location.state) {
      const assetData = location.state.data;
      setFileList([
        {
          key: assetData.fileName,
          fileName: assetData.fileName,
          format: assetData.format,
          fileSize: assetData.size,
          artist: assetData.artist,
          track: assetData.track,
          notes: assetData.notes,
          progress: 100,
          uploadKey: id ? assetData.uploadKey : uploadKey,
        },
      ]);
    }
  }, [id]);

  const isAnyFileUploading =
    fileList.length > 0 &&
    fileList.some((file) => file.progress < 100 || !file.uploadKey);
  const canSubmit = fileList.length > 0 && !isAnyFileUploading && !loading;

  const handleUploadChange = (info: UploadChangeParam) => {
    // alert("test");
    // if (info.file.status === "done" || info.file.status === "error") {
    // alert("done---");
    const newFile: FileData = {
      key: info.file.uid,
      fileName: info.file.name,
      format: info.file.type || "N/A",
      fileSize: info.file.size ?? 0,
      artist: "",
      track: "",
      notes: "",
      progress: 0,
    };
    console.log("newFile", newFile);
    setFileList((prevList) => {
      if (prevList.some((f) => f.key === newFile.key)) return prevList;
      return [...prevList, newFile];
    });
  };
  const handleCustomRequest = async (options: any) => {
    const { file, onSuccess, onError, onProgress } = options;
    const newFile: FileData = {
      key: file.uid,
      fileName: file.name,
      format: file.type ? file.type.split("/")[1] : "N/A",
      fileSize: file.size ?? 0,
      artist: "",
      track: "",
      notes: "",
      progress: 0,
      uploadKey: "",
    };

    setFileList((prev) => [...prev, newFile]);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`${BASE_URL}upload/file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          detection_auth: getCookie("detection_auth"),
        },
        onUploadProgress: (event) => {
          const percent = event.total
            ? Math.floor((event.loaded / event.total) * 100)
            : 0;
          setFileList((prev) =>
            prev.map((f) =>
              f.key === file.uid ? { ...f, progress: percent } : f,
            ),
          );
          onProgress?.({ percent });
        },
      });

      setFileList((prev) =>
        prev.map((f) =>
          f.key === file.uid
            ? {
                ...f,
                uploadKey: res.data.referenceKey,
                fileName: res.data.fileName,
                progress: 100,
                format: res.data.fileFormat,
                fileSize: res.data.fileSize,
              }
            : f,
        ),
      );

      showNotySucess(`${file.name} uploaded successfully.`);
      onSuccess?.();
    } catch (e) {
      setFileList((prev) => prev.filter((f) => f.key !== file.uid));
      message.error(`${file.name} failed to upload.`);
      onError?.(e);
    }
  };
  // const handleCustomRequest = async (options: any) => {
  //   const { file, onSuccess, onError, onProgress } = options;
  //   console.log("uploaded filess", file);
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   console.log("file.type.split", file.type.split("/")[1]);
  //   const newFile: FileData = {
  //     key: file.uid,
  //     fileName: file.name,
  //     format: file.type ? file.type.split("/")[1] : file.type || "N/A",
  //     fileSize: file.size ?? 0,
  //     artist: "",
  //     track: "",
  //     notes: "",
  //     progress: 0,
  //     uploadKey: "",
  //   };
  //   console.log("New file generation--", newFile);

  //   setFileList((prevList) => [...prevList, newFile]);

  //   try {
  //     await axios
  //       .post(`${BASE_URL}upload/file`, formData, {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           detection_auth: getCookie("detection_auth"),
  //         },
  //         onUploadProgress: (event: any) => {
  //           const percent = Math.floor((event.loaded / event.total) * 100);
  //           setFileList((prevList) => {
  //             const updatedList = prevList.map((f) => {
  //               if (f.fileName === file.name) {
  //                 return { ...f, progress: percent };
  //               }
  //               return f;
  //             });
  //             console.log("After updating upload key", updatedList);
  //             return updatedList;
  //           });
  //           onProgress?.({ percent, event });
  //         },
  //       })
  //       .then((res: any) => {
  //         console.log("response of initial uploads", res.data);
  //         setFileList((prevList) => {
  //           const updatedList = prevList.map((f) => {
  //             if (f.key === file.uid) {
  //               return {
  //                 ...f,
  //                 uploadKey: res.data.referenceKey,
  //                 fileName: res.data.fileName,
  //                 format: res.data.fileFormat,
  //                 fileSize: res.data.fileSize,
  //               };
  //             }
  //             return f;
  //           });
  //           console.log("After updating upload key", updatedList);
  //           return updatedList;
  //         });
  //       });
  //     showNotySucess(`${file.name} uploaded successfully.`);
  //     onSuccess?.();
  //   } catch (e) {
  //     message.error(`${file.name} failed to upload.`);
  //     onError?.(e);
  //   }
  // };
  //   postApi(data, "/assets/create", "Successfully Created The Asset!")
  //   .then((res) => {
  //     form.resetFields();
  //     setLoading(false);
  //   }

  const props: UploadProps = {
    showUploadList: {
      extra: ({ size = 0 }) => (
        <span style={{ color: "#cccccc" }}>
          ({(size / 1024 / 1024).toFixed(2)}MB)
        </span>
      ),

      showRemoveIcon: true,
    },
  };
  const removeKeys = (data, keysToRemove) => {
    return data.map((obj) => {
      const newObj = { ...obj };
      keysToRemove.forEach((key) => delete newObj[key]);
      return newObj;
    });
  };
  // const allowedExt = [".mp3", ".mp4", ".wav", ".flac"];
  let shownNotes = new Set<string>();
  const checkFile = (file: RcFile) => {
    // const ext = "." + file.name.split(".").pop().toLowerCase();
    const ext =
      "." + file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
    const config = FILE_UPLOAD_CONFIG[ext];
    if (!config) {
      showNotyError(
        `Allowed types: ${Object.keys(FILE_UPLOAD_CONFIG).join(", ")}`,
      );
      return Upload.LIST_IGNORE;
    }

    // if (config.showInfoNote && config.noteMessage && !shownNotes.has(ext)) {
    //   showNotyInfo(config.noteMessage);
    //   shownNotes.add(ext);
    // }

    return false;

    // if (!allowedExt.includes(ext)) {
    //   showNotyError(
    //     `Only these file types are allowed: ${allowedExt.join(", ")}`
    //   );
    //   return Upload.LIST_IGNORE;
    // }

    // return false;
  };

  const handleSubmit = async () => {
    setLoading(true);
    // const keysToExclude = ["key", "progress"];
    // const data = removeKeys(fileList, keysToExclude);
    const allFormValues = form.getFieldsValue();
    const updatedFileList = fileList.map((file) => {
      const updatedFields = allFormValues[file.key];
      return {
        ...file,
        ...updatedFields,
      };
    });
    setFileList(updatedFileList);

    postApi(
      updatedFileList,
      "/assets/create-multiple",
      "Successfully Created The Asset!",
    )
      .then((res) => {
        // console.log("multiple file upload response", res);
        form.resetFields();
        setLoading(false);
        setTimeout(() => {
          //   if (res.watermark) {
          // showNotyInfo("Watermark was found on the asset!");
          // if (user.isAdmin) {
          setActiveButton("search");
          navigate("/search");
          // navigate(
          //   `/search/${res[0].uploadKey}?fileName=${res[0].fileName}`,
          //   {
          //     state: {
          //       data: res[0],
          //     },
          //   }
          // );
          // }
          setFileList([]);
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
        setFileList([]);
        showNotyError(err.message);
        console.log("Error from create Asset--", err.message);
      });
  };

  return (
    <div>
      <Title className="page-title">UPLOAD ASSET</Title>
      <Row>
        <Col span={24}>
          <Upload.Dragger
            {...props}
            name="files"
            maxCount={1}
            accept=".mp3,.wav,.flac, .m4a, .aac, .aiff,.ogg,.opus,.mp4,.mov,.webm,.mv4,.mkv"
            beforeUpload={checkFile}
            multiple={true}
            // beforeUpload={() => false}

            onChange={handleCustomRequest}
            // onChange={handleUploadChange}
            // fileList={fileList}
            // showUploadList={{
            //   showRemoveIcon: false,
            //   showPreviewIcon: false,
            // }}
            style={{
              background: "rgb(0,25,58,0.8)",
              minHeight: 220,
              border: "none",
              borderRadius: "unset",
            }}
            showUploadList={false}
          >
            <span className="ant-upload-text">
              <p>CLICK TO BROWSE</p>
              <p className="horizontal-line">OR</p>
              <p>DRAG & DROP HERE</p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  width: "100%",
                  marginBottom: 8,
                }}
              >
                {/* The wrapper that creates the clean, aligned block */}
                <div
                  style={{
                    display: "inline-block", // Keeps the wrapper only as wide as its content
                    textAlign: "left", // Ensures the left edges are flush
                    fontSize: 12,
                    lineHeight: "1.6",
                  }}
                >
                  <Text type="secondary" style={{ display: "flex" }}>
                    {/* Fixed width on the label pushes the extensions into a perfect column */}
                    <span
                      style={{
                        fontWeight: "bold",
                        width: 150,
                        fontSize: 14,
                        flexShrink: 0,
                      }}
                    >
                      Supported Audio Formats:
                    </span>
                    <span style={{ lineHeight: "1.2" }}>
                      .wav, .mp3, .m4a, .aac, .aiff, .flac, .ogg, .opus
                    </span>
                  </Text>

                  <Text type="secondary" style={{ display: "flex" }}>
                    <span
                      style={{
                        fontWeight: "bold",
                        width: 150,
                        fontSize: 14,
                        flexShrink: 0,
                      }}
                    >
                      Supported Video Formats:
                    </span>
                    <span style={{ lineHeight: "1.2" }}>
                      .mp4, .mov, .webm, .m4v, .mkv
                    </span>
                  </Text>
                </div>
              </div>
            </span>
          </Upload.Dragger>
        </Col>
        {fileList.length > 0 && (
          <Row justify="end" style={{ width: "100%", marginTop: "20px" }}>
            <Col>
              {/* <Button
                type="primary"
                onClick={handleSubmit}
                htmlType="submit"
                loading={loading}
                disabled={fileList.length === 0}
              >
                Submit
              </Button> */}
              <Button
                type="primary"
                onClick={handleSubmit}
                loading={loading || isAnyFileUploading} // Visual feedback while waiting for that 30MB file
                disabled={!canSubmit} // Button is dead until everyone crosses the finish line
              >
                {isAnyFileUploading ? "Uploading..." : "Submit"}
              </Button>
            </Col>
          </Row>
        )}
      </Row>
      <br />
      <br />
      {fileList.length > 0 && (
        <EditableTable
          fileList={fileList}
          setFileList={setFileList}
          form={form}
        />
      )}
    </div>
  );
};

export default UploadPage;
